import React, { useEffect, useState } from 'react'
import { components } from 'cng-web-lib'
import { getStatusMetadata } from '../../../../common/NACommon'
import CngField from '../../../../components/cngcomponents/CngField'
import {
  Box,
  Collapse,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  Paper,
  Select,
  Typography
} from '@material-ui/core'

const {
  button: { CngButton, CngIconButton },
  CngDialog
} = components

function SubmitAllShipmentMessageDialog(props) {
  const {
    manifestId,
    onClose,
    onSubmitShipment,
    open,
    aceHighwayShipmentTranslationText
  } = props

  const [submissionStatusType, setSubmissionStatusType] = useState('ALL')

  return (
    <CngDialog
      dialogContent={
        <Box paddingTop={1}>
          <Grid container spacing={2}>
              <Grid item xs={12}>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                      <StatusItem
                        submissionStatusType={submissionStatusType}
                        setSubmissionStatusType={setSubmissionStatusType}
                        aceHighwayShipmentTranslationText={aceHighwayShipmentTranslationText}
                      />
                  </Grid>
                </Grid>
              </Grid>
          </Grid>
        </Box>
      }
      dialogAction={
        <Grid container justify='space-between' spacing={2}>
          <Grid item xs='auto'>
            <CngButton color='secondary' onClick={onClose} size='medium'>
              {aceHighwayShipmentTranslationText.backButton}
            </CngButton>
          </Grid>
          <Grid item xs='auto'>
            <Grid container justify='flex-end' spacing={2}>
              <Grid item xs='auto'>
                <CngButton
                  color='primary'
                  onClick={() => {
                    onSubmitShipment({
                      manifestId,
                      status: submissionStatusType
                    })
                    onClose()
                  }}
                  size='medium'
                >
                  {aceHighwayShipmentTranslationText.submitToCustoms}
                </CngButton>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      }
      dialogTitle='Submission Shipments Status'
      fullWidth
      maxWidth='md'
      onClose={onClose}
      open={open}
      shouldShowCloseButton
    />
  )
}

export default SubmitAllShipmentMessageDialog

function StatusItem(props) {
  const {
    submissionStatusType,
    setSubmissionStatusType,
    aceHighwayShipmentTranslationText
  } = props

  function handleMessageFunctionChange(event) {
    setSubmissionStatusType(event.target.value)
  }

  return (
    <Paper variant='outlined'>
      <Box padding={2}>
        <Grid alignItems='center' container spacing={2}>
          <Grid item xs={12} md>
            <Grid container spacing={2}>
              <Grid item xs={12} md>
                <FormControl variant='outlined' fullWidth>
                  <InputLabel htmlFor={`message-function-label-${0}`}>
                    {'Submit for'}
                  </InputLabel>
                  <Select
                    label={aceHighwayShipmentTranslationText.messageFunction}
                    inputProps={{
                      id: `message-function-label-${0}`
                    }}
                    native
                    onChange={handleMessageFunctionChange}
                    size='small'
                    value={submissionStatusType}
                  >
                    <option value='ALL'>
                      {aceHighwayShipmentTranslationText.all}
                    </option>
                    <option value='1005'>
                      {aceHighwayShipmentTranslationText.draft}
                    </option>
                    <option value='1001'>
                      {aceHighwayShipmentTranslationText.rejected}
                    </option>
                    <option value='1003'>
                      {aceHighwayShipmentTranslationText.cancelled}
                    </option>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Paper>
  )
}
